import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export function getToken() {
  return localStorage.getItem("klt_token") || sessionStorage.getItem("klt_token");
}

export function setToken(token, remember) {
  if (remember) {
    localStorage.setItem("klt_token", token);
    sessionStorage.removeItem("klt_token");
  } else {
    sessionStorage.setItem("klt_token", token);
    localStorage.removeItem("klt_token");
  }
}

export function clearToken() {
  localStorage.removeItem("klt_token");
  sessionStorage.removeItem("klt_token");
}

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function fileUrl(path, token) {
  return `${API}/files/${path}?auth=${token || ""}`;
}

let _dlToken = null;
let _dlExp = 0;
export async function getDownloadToken() {
  const now = Date.now();
  if (_dlToken && now < _dlExp) return _dlToken;
  const { data } = await api.get("/auth/download-token");
  _dlToken = data.token;
  _dlExp = now + Math.max(0, (data.expiresIn || 600) - 60) * 1000;
  return _dlToken;
}

export default api;
